var testKey = '__test_storage_support__';
var testValue = '@@test';
var testStorageSupport = function testStorageSupport(type) {
  if (type === void 0) {
    type = 'local';
  }

  try {
    var storage = type === 'session' ? window.sessionStorage : window.localStorage;
    storage.setItem(testKey, testValue);

    if (storage.getItem(testKey) !== testValue) {
      return false;
    }

    storage.removeItem(testKey);
    return true;
  } catch (err) {
    return false;
  }
};
var createStorage = function createStorage() {
  var memoryStorage = Object.create(null);
  return {
    getItem: function getItem(key) {
      var value = memoryStorage[key];
      return typeof value === 'string' ? value : null;
    },
    setItem: function setItem(key, value) {
      memoryStorage[key] = value;
    },
    removeItem: function removeItem(key) {
      delete memoryStorage[key];
    },
    clear: function clear() {
      memoryStorage = Object.create(null);
    }
  };
};
var index = /*#__PURE__*/
createStorage();

export default index;
export { createStorage, testStorageSupport };
